const BuyMeACoffeeButton = () => {
  return (
    <a
      className="buy-me-a-coffee-button"
      href="https://www.buymeacoffee.com/pujan7"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="coffee-icon">☕</span>
      <span className="button-text">Buy me a coffee</span>
    </a>
  );
};

export default BuyMeACoffeeButton;
